export const CouponConstants = {
    COUPON_ADDED_REQUEST:'COUPON_ADDED_REQUEST',
    COUPON_ADDED_SUCCESS:'COUPON_ADDED_SUCCESS',
    COUPON_ADDED_FAILURE:'COUPON_ADDED_FAILURE',

    GET_COUPON_LIST_REQUEST:'GET_COUPON_LIST_REQUEST',
    GET_COUPON_LIST_SUCCESS:'GET_COUPON_LIST_SUCCESS',
    GET_COUPON_LIST_FAILURE:'GET_COUPON_LIST_FAILURE',

    UPDATE_COUPON_REQUEST:'UPDATE_COUPON_REQUEST',
    UPDATE_COUPON_SUCCESS:'UPDATE_COUPON_SUCCESS',
    UPDATE_COUPON_FAILURE:'UPDATE_COUPON_FAILURE',

    DELETE_COUPON_REQUEST:'DELETE_COUPON_REQUEST',
    DELETE_COUPON_SUCCESS:'DELETE_COUPON_SUCCESS',
    DELETE_COUPON_FAILURE:'DELETE_COUPON_FAILURE'
    
};
